module.exports = __webpack_public_path__ + "img/instragram.0a5d8ad2.png";